import { render } from "./localization.vue?vue&type=template&id=d52498c8"
import script from "./localization.vue?vue&type=script&lang=js"
export * from "./localization.vue?vue&type=script&lang=js"
script.render = render

export default script